<div class="row config-container">
  <div class="col-2 signifyBookmd config-text" id="AUXOUTPUT-outputvoltage-text">Output voltage</div>
  <div class="col-4">
    <select id="AUXOUTPUT-outputvoltage-dropdown" [(ngModel)]="selectedOutputVoltage" class="signifyBookmd select-dimming"
      (change)="onOutputVoltageChange($event.target.value)">
      @for (voltage of outputVoltages; track voltage) {
        <option [value]="voltage" class="info-val" id="AUXOUTPUT-outputvoltage-option-{{voltage}}">
          {{ voltage }}
        </option>
      }
    </select>
  </div>
  <div class="col-6"></div>
</div>
